import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as S from './ReceivementOverviewFilters.styles'
import * as selectors from '../../ReceivementSelectors'
import { useParams } from 'react-router-dom'
import { actions } from '../../ReceivementState'
import { Checkbox } from 'src/components/receivement-components/components'
import { ReceivementSortBySelect } from './ReceivementSortBySelect'
import { ReceivementSearchInput } from '../ReceivementSearchInput'
import { useStore } from 'src/utils/store'

interface Props {
  badge: string;
}

const ReceivementOverviewFilters = ({ badge }: Props) => {
  const dispatch = useDispatch()
  const store = useStore()

  const { receivementId } = useParams<{ receivementId?: string }>()
  const onlyDivergents = useSelector(selectors.selectOnlyDivergents)
  const sortBy = useSelector(selectors.selectSortBy)

  const handleOverview = React.useCallback(async () => {
    if (!receivementId) return
    const { productDescription } = store.getState().receivement.overviewFilters

    dispatch(
      actions.getOverview({
        badge,
        receivementId,
        onlyDivergents,
        productDescription,
        sortBy,
      }),
    )
  }, [badge, dispatch, onlyDivergents, receivementId, sortBy, store])

  React.useEffect(() => {
    if (!badge) {
      return
    }

    handleOverview()
  }, [handleOverview, badge])

  const handleOnlyDivergents = React.useCallback(() => {
    dispatch(
      actions.setOnlyDivergentsFilter({ onlyDivergents: !onlyDivergents }),
    )
  }, [dispatch, onlyDivergents])

  const handleProductFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(
      actions.setProductDescriptionFilter({
        productDescription: e.target.value,
      }),
    )
  }

  const handleSearch = React.useCallback(() => {
    handleOverview()
  }, [handleOverview])

  React.useCallback(() => () => {
    dispatch(actions.clearOverviewFilters())
  }, [dispatch])

  return (
    <S.FiltersWrapper>
      <S.SecondaryFiltersWrapper>
        <ReceivementSearchInput onChangeText={handleProductFilter} handleSearch={handleSearch}/>
      </S.SecondaryFiltersWrapper>

      <S.SecondaryFiltersWrapper>
        <S.WrapperCheckbox>
          <Checkbox
            name='ars-filter'
            labelTitle='Ver somente ARs com divergência'
            checked={onlyDivergents}
            labelStyle={{
              marginLeft: '0.75rem',
              fontFamily: 'Work Sans',
              color: '#3B3B3B',
              fontSize: '14px',

            }}
            labelPosition='right'
            onChange={handleOnlyDivergents}
            style={{ width: '1rem', height: '1rem' }}
          />
        </S.WrapperCheckbox>
        <ReceivementSortBySelect />
      </S.SecondaryFiltersWrapper>
    </S.FiltersWrapper>
  )
}

export { ReceivementOverviewFilters }
